import script from "./Archiver.vue?vue&type=script&setup=true&lang=js"
export * from "./Archiver.vue?vue&type=script&setup=true&lang=js"

import "./Archiver.vue?vue&type=style&index=0&id=22a66d8b&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22a66d8b"]])

export default __exports__